import React from "react";

export default function AppIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7164 3.67317C16.8377 2.79449 15.413 2.79449 14.5343 3.67317L11.9434 6.26405C11.7212 5.2551 10.8218 4.50018 9.74609 4.50018H5.24609C4.00346 4.50018 2.99609 5.50754 2.99609 6.75018V18.7472C2.99609 19.5126 3.37831 20.1888 3.9623 20.5953C4.32718 20.8505 4.77127 21.0002 5.25031 21.0002H17.2503C18.4929 21.0002 19.5003 19.9928 19.5003 18.7502V14.2502C19.5003 13.2017 18.783 12.3206 17.8125 12.071L20.3723 9.51114C21.251 8.63247 21.251 7.20785 20.3723 6.32916L17.7164 3.67317ZM14.3674 12.0002H11.9961V9.62892L14.3674 12.0002ZM15.5949 4.73384C15.8879 4.44095 16.3628 4.44095 16.6557 4.73384L19.3116 7.38983C19.6046 7.68272 19.6046 8.15759 19.3116 8.45049L16.6557 11.1065C16.3628 11.3994 15.8879 11.3994 15.5949 11.1065L12.939 8.45049C12.6461 8.15759 12.6461 7.68272 12.939 7.38983L15.5949 4.73384ZM10.4961 6.75018V12.0002H4.49609V6.75018C4.49609 6.33597 4.83188 6.00018 5.24609 6.00018H9.74609C10.1603 6.00018 10.4961 6.33597 10.4961 6.75018ZM4.50031 18.7502V13.5002H10.4961V19.4972H5.24609C5.08684 19.4972 4.93916 19.4475 4.81772 19.3629C4.62568 19.2272 4.50031 19.0032 4.50031 18.7502ZM11.9961 13.5002H17.2503C17.6645 13.5002 18.0003 13.836 18.0003 14.2502V18.7502C18.0003 19.1643 17.6645 19.5002 17.2503 19.5002H11.9961V13.5002Z"
        fill="white"
      />
    </svg>
  );
}
